package nl.astraeus.wiki.messages

class CreateWikiMessage() : Message(
  MessageType.CREATE_WIKI,
) {

  constructor(msg: String) : this() {
    this.message = msg

    checkType(MessageType.CREATE_WIKI)
  }

}
